import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import TextLogoIcon from "sweet-web/components/icons/TextLogoIcon";
import OutlineButton from "sweet-web/components/universal/Button/OutlineButton";
import { colors } from "sweet-web/lib/styles";
import { RootState } from "sweet-web/redux";
import * as selectors from "sweet-web/redux/selectors";

const Wrapper = styled.div<{ visible: boolean }>`
  height: auto;
  background-color: ${colors.nearWhite};
  padding: 60px;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  display: ${props => (props.visible ? "flex" : "none")};
  @media screen and (max-width: 600px) {
    /* mobile styling */
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 20px 20px 100px 20px;
  }
`;

const Links = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-start;
  @media screen and (max-width: 600px) {
    /* mobile styling */
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
  }
`;

const LinksSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
  margin-left: 30px;
  @media screen and (max-width: 600px) {
    /* mobile styling */
    align-items: flex-start;
    margin-left: 0;
    margin-top: 30px;
  }
`;

const LinksSectionLabel = styled.h5`
  font-size: 12px;
  font-weight: 600;
  color: ${colors.nearBlack};
  margin-bottom: 10px;
`;

const Link = styled.a`
  font-size: 12px;
  font-weight: 600;
  color: ${colors.gray};
  text-decoration: none;
  text-align: right;
  padding: 2px 0px;
  margin: 3px 0px;
  border-top: 1px solid ${colors.lighterGray};
  border-bottom: 1px solid transparent;
  &:first-of-type {
    border-top: none;
  }
  transition: all 100ms cubic-bezier(0.21, 0.94, 0.64, 0.99);
  &:hover {
    color: ${colors.primary};
    border-bottom: 1px solid ${colors.primary};
  }
`;

type Props = RouteComponentProps & ConnectedProps<typeof connector>;

const Footer: React.FC<Props> = props => {
  // hide footer on certain pages
  const visible =
    !props.location.pathname.includes("/c/") &&
    !(props.location.pathname.includes("/v/") && window.innerWidth < 600) &&
    !props.location.pathname.includes("/photos");

  return (
    <Wrapper visible={visible}>
      <TextLogoIcon size={40} color={colors.primary} />
      <Links>
        <LinksSection>
          <LinksSectionLabel>Join Us</LinksSectionLabel>
          <Link href="/list">List a Venue</Link>
          <Link href="mailto:team@sweetbookings.co?subject=Sweet Careers">
            Careers
          </Link>
          <Link href="mailto:team@sweetbookings.co?subject=Sweet Press">
            Press
          </Link>
        </LinksSection>
        <LinksSection>
          <LinksSectionLabel>Contact</LinksSectionLabel>
          <Link href="https://www.city.yale.edu/">Tsai CITY @ Yale</Link>
          <Link href="mailto:team@sweetbookings.co">team@sweetbookings.co</Link>
          <Link href="tel:+19149541454">+1 (914) 954-1454</Link>
        </LinksSection>
        <LinksSection>
          <LinksSectionLabel>Legal</LinksSectionLabel>
          <Link href="#">Sweet, Inc.</Link>
          <Link href="/terms">Terms of Use</Link>
          <Link href="/privacy">Privacy Policy</Link>
        </LinksSection>
      </Links>
    </Wrapper>
  );
};

const mapState = (state: RootState, ownProps: RouteComponentProps) => ({});
const connector = connect(mapState);

export default withRouter(connector(Footer));
